import { c as _c } from "react/compiler-runtime";
import { useGetMarket, useGetMarketField } from '../../generated/hooks/useGetMarket.gen.js';
import { outcomeHuesForMarket } from '../../platform/shared/outcome-colors.js';
/** Standalone rows need the full market to preserve collision-resolved identity. */
export function useMarketOutcomeHue(marketPubkey, outcomeIndex) {
  const $ = _c(3);
  const hues = useMarketOutcomeHues(marketPubkey);
  let t0;
  if ($[0] !== hues || $[1] !== outcomeIndex) {
    t0 = outcomeIndex === undefined ? undefined : hues?.get(outcomeIndex);
    $[0] = hues;
    $[1] = outcomeIndex;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
}
export function useMarketOutcomeHues(marketPubkey) {
  const $ = _c(9);
  const pubkey = marketPubkey ?? "";
  let t0;
  if ($[0] !== pubkey) {
    t0 = {
      pubkey
    };
    $[0] = pubkey;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t1 = pubkey.length > 0;
  let t2;
  if ($[2] !== t1) {
    t2 = {
      enabled: t1,
      isolateNestedEntityRenders: true
    };
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  useGetMarket(t0, t2);
  let t3;
  if ($[4] !== pubkey) {
    t3 = {
      pubkey
    };
    $[4] = pubkey;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const outcomes = useGetMarketField(t3, "outcomes");
  if (outcomes === undefined) {
    return;
  }
  let t4;
  if ($[6] !== outcomes || $[7] !== pubkey) {
    const hues = outcomeHuesForMarket(outcomes.map(_temp), "precise-order", pubkey);
    t4 = new Map(outcomes.flatMap((outcome_0, position) => {
      const hue = hues[position];
      return hue === undefined ? [] : [[outcome_0.outcomeIndex, hue]];
    }));
    $[6] = outcomes;
    $[7] = pubkey;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}
function _temp(outcome) {
  return {
    title: outcome.label,
    index: outcome.outcomeIndex
  };
}